export default["__VITE_ASSET__C42g6$G2__","__VITE_ASSET__BFTechD___"];